import React from 'react';
import { AvatarName } from '../../dashboard/inbox/AvatarName';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import clsx from 'clsx';
import { Typography } from '../typography';

interface Props {
	firstname: string;
	lastname: string;
	username: string;
	className?: string;
	classNameButton?: string;
	photoUrl?: string;
	isCreator?: boolean;
	onClick?: () => void;
}

export const UserBadge: React.FC<Props> = ({
	firstname,
	lastname,
	username,
	className,
	classNameButton,
	isCreator,
	photoUrl,
	onClick,
}) => {
	return (
		<div
			className={clsx(
				'bg-transparent border border-gray-30 rounded-2xl',
				'px-4 h-12 flex items-center justify-between w-full md:w-[16.25rem]',
				className
			)}
		>
			<AvatarName
				photoUrl={photoUrl || ''}
				size="small"
				name={username}
				firstname={firstname}
				lastname={lastname}
				classNameText="!text-base"
				isBold
			/>
			{isCreator ? (
				<Typography type="regular-12" className="text-gray-35">
					Creator
				</Typography>
			) : (
				<button
					type="button"
					onClick={onClick}
					className={clsx(classNameButton)}
				>
					<Icon src={Icons.trash} className="!size-5 !text-main-red" />
				</button>
			)}
		</div>
	);
};
